var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.953 0.857247C21.0007 0.743668 21.0124 0.619245 20.9866 0.499401C20.9608 0.379557 20.8986 0.269563 20.8078 0.183056C20.717 0.0965492 20.6015 0.037333 20.4756 0.012749C20.3498 -0.011835 20.2192 -0.000705733 20.0999 0.044757L1.00764 7.31842H1.00632L0.413095 7.54341C0.300736 7.5861 0.202952 7.65753 0.130544 7.74982C0.0581359 7.84211 0.0139222 7.95167 0.00278663 8.06639C-0.00834894 8.18111 0.014027 8.29653 0.0674428 8.3999C0.120859 8.50327 0.203235 8.59057 0.305473 8.65215L0.84358 8.97714L0.844892 8.97964L7.4006 12.9521L11.5716 19.1958L11.5742 19.1983L11.9154 19.7108C11.9803 19.8078 12.072 19.8858 12.1805 19.9364C12.2889 19.9869 12.4099 20.008 12.5301 19.9973C12.6504 19.9866 12.7652 19.9444 12.8619 19.8756C12.9586 19.8067 13.0335 19.7138 13.0783 19.607L20.953 0.857247ZM18.5473 3.21972L8.71174 12.5871L8.42957 12.1646C8.37786 12.0871 8.30885 12.0213 8.22745 11.9721L7.78384 11.7034L17.6194 2.33598L19.1654 1.74724L18.5486 3.21972H18.5473Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/sendIcon.86f7474223451240ccb91ca8190d4465.svg";
export { ForwardRef as ReactComponent };